import Model, { attr } from '@ember-data/model';

export default class MailchimpFundSettingModel extends Model {
  @attr('string') declare mailchimpSettingId: string;
  @attr('string') declare fundId: string;
  @attr('string') declare mailchimpListId: string;
  @attr() declare mergeVars: {
    name: string;
    tag: string;
    field_type: string;
    attribute: string;
    max_length?: number;
  }[];
  @attr() apiMergeFields: any;
  @attr('boolean') declare syncGroups: boolean;
  @attr('boolean') declare syncGroupsToInterestCategory: boolean;
  @attr('boolean') declare syncGroupsToTags: boolean;
}
